
declare function moment(something:any,othersomething?:any): any;
declare namespace moment{
    export var ISO_8601: any;
    export function utc(val:any):any;
}
declare namespace L{
    export function areaSelect(vals: any): any
    export function rectangle(vals?:any, vals2?:any): any
}

    export class LatLngZoom {
        constructor(public lat:number, public lng:number, public zoom:number) {
        }
    }

    export class Layers {
        baselayers:BaseLayers;

        constructor(url:string, bounds:any[]) {
            this.baselayers = new BaseLayers();
        }
    }

    export class BaseLayers {
        constructor() {
        }
    }

    export class BackgroundImage {
        name:string = "Background";
        type:string = "imageOverlay";
        layerParams:LayerParams = new LayerParams(false, true);

        constructor(public url:string, public bounds:any[]) {
        }
    }

    export class LayerParams {
        constructor(public showOnSelector:boolean, public noWrap:boolean) {
        }
    }

    export class MapDefaults {
        constructor(public scrollWheelZoom:boolean, public crs:any, public maxZoom:number, public minZoom:number) {
        }
    }

    export class MapEvents {
        map:any;

        constructor(events:string[]) {
            this.map = {};
            this.map.enable = events;
            this.map.logic = "emit";
        }
    }
